module.exports = __webpack_public_path__ + "static/media/check_circle.126814d0.svg";